<!-- <waitLoading *ngIf="!isLoaded()"></waitLoading> -->
<ng-container *ngIf="isLoaded()">
  <div class="col-12">
    <h3>{{ 'Envelope.title' | translate }}</h3>
  </div>
  <div class="col-12 py-2 px-2">
    <p-table [value]="data" [multiSortMeta]="multiSortMeta" dataKey="identifier" [responsive]="true"
      [expandedRowKeys]="expandedRows" sortMode="multiple">
      <ng-template pTemplate="header">
        <tr>
          <th [style.width]="'2%'"></th>
          <th [style.width]="'3%'"></th>
          <th [style.width]="'20%'">{{ colHeaders[0] | translate }}</th>
          <th [style.width]="'35%'">{{ colHeaders[1] | translate }}</th>
          <th [style.width]="'20%'">{{ colHeaders[2] | translate }}</th>
          <th [style.width]="'10%'">{{ colHeaders[3] | translate }}</th>
          <th [style.width]="'10%'">{{ colHeaders[4] | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-expanded="expanded" let-phase>
        <tr>
          <td>
            <!-- <a href="#" [pRowToggler]="phase">
              <i [ngClass]="
                  expanded ? 'fas fa-1-5x fa-chevron-down' : 'fas fa-1-5x  fa-chevron-right'
                "></i>
            </a> -->
          </td>
          <td>
            <ng-container *ngIf="!containEnvelopes(phase)">
              <a (click)="showNotContainsEnvelope()">
                <i class="fas fa-lg fa-exclamation-circle text-warning"
                  pTooltip="{{'TenderDefinition.click2ShowErrors' | translate}}" tooltipPosition="right"></i>
              </a>
            </ng-container>
            <ng-container *ngIf="containEnvelopes(phase)">
              <ng-container *ngIf="validations && validations.get(phase.identifier)?.result === LOADINGRESULT_TYPE">
                <i class="fa fa-spinner loading-spin" aria-hidden="true"
                  pTooltip="{{'TenderDefinition.click2ShowErrors' | translate}}" tooltipPosition="right"></i>
              </ng-container>
              <ng-container
                *ngIf="validations && validations.get(phase.identifier)?.result && validations?.get(phase.identifier)?.result !== 'OK'">
                <a (click)="showValidationResultById(phase.identifier)">
                  <i class="fas fa-lg fa-exclamation-circle text-warning"
                    pTooltip="{{'TenderDefinition.click2ShowErrors' | translate}}" tooltipPosition="right"></i>
                </a>
              </ng-container>
            </ng-container>
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[0] | translate }}</span> {{ phase.type?.description }}
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[1] | translate }}</span> {{ this.getEnvelopes(phase) }}
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[2] | translate }}</span> {{ phase.initDate | date: 'dd/M/yy
            HH:mm' }} - {{ phase.endDate | date: 'dd/M/yy HH:mm' }}
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[3] | translate }}</span> {{ this.getStateDescription(phase) }}
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[4] | translate }}</span>
            <div class="btn-group">
              <button class="btn btn-sm btn-primary t-action-button"
                [attr.disabled]="isPhaseClosed(phase) ? 'disabled' : null" aria-expanded="false"
                (click)="editData(phase)" appNoDblClick title="{{ 'General.edit' | translate}}">
                <i class="fas fa-pencil-alt" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm btn-secondary t-action-button" *ngIf="!isPhasePublished(phase)"
                [attr.disabled]="!isEditingPhase(phase) ? 'disabled' : null" aria-expanded="false"
                (click)="publishPhase(phase)" appNoDblClick title="{{ 'TenderingPhase.actions.publish' | translate}}">
                <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
              </button>
              <!-- <button class="btn btn-sm btn-secondary t-action-button" *ngIf="isPhasePublished(phase)"
                aria-expanded="false" (click)="unPublishPhase(phase)" appNoDblClick>
                <i class="fas fa-cloud-download-alt" aria-hidden="true"></i>
              </button> -->
              <button class="btn btn-sm btn-secondary t-action-button"
                [attr.disabled]="isPhasePreviouslyPublished(phase) ? 'disabled' : null" aria-expanded="false"
                (click)="deleteData(phase)" appNoDblClick title="{{ 'General.delete' | translate}}">
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="text-center">
          <td colspan="7">{{ 'General.noData' | translate }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-phase>
        <tr>
          <td colspan="7">
            <div class="openingCommittees">
              <ng-container *ngFor="let openingCommittee of getOrderedCommittees(phase)">
                <tenderingPhaseEvent [project]="project" [phase]="phase" [openingCommittee]="openingCommittee"
                  [avaliableEvaluationCommittees]="tenderEvaluationCommittees" (updated)="emitUpdate(phase.identifier)"
                  (deletedCommitee)="emitDeletedCommitee($event)">
                </tenderingPhaseEvent>
              </ng-container>
            </div>
            <!-- nuevo evento-->
            <tenderingPhaseEvent [project]="project" [phase]="phase"
              [avaliableEvaluationCommittees]="tenderEvaluationCommittees" (updated)="emitUpdate(phase.identifier)">
            </tenderingPhaseEvent>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="flex-row py-2">
    <div class="d-flex flex-row-reverse">
      <button class="btn btn-sm btn-outline-primary float-right" (click)="this.newData()" appNoDblClick
        title="{{ 'TenderingPhase.add' | translate }}">
        <i class="fas fa-plus"></i> {{ 'TenderingPhase.add' | translate }} </button>
    </div>
  </div>
</ng-container>
<p-dialog header="{{'General.warning' | translate" [resizable]="true" [(visible)]="showValidationInfo" [closable]="true"
  [responsive]="true" [dismissableMask]="true" [closeOnEscape]="true" [modal]="true" [appendTo]="'body'"
  header="{{ 'Communications.audit.errorsTitle' | translate }}" (onHide)="closeValidationResult()">
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row">
        <validationResultMessages [validationresult]="this.validationResult"></validationResultMessages>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>